import { render, staticRenderFns } from "./EstoqueAtenderSolicitacao.vue?vue&type=template&id=4b9fe84b&"
import script from "./EstoqueAtenderSolicitacao.vue?vue&type=script&lang=js&"
export * from "./EstoqueAtenderSolicitacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports